// JOBE-0044.4: TranslatedCaption — the "Translated to query_entities"
// trust receipt. Always renders when ≥1 removable chip is active.
// Reads the chip array and emits `<wirePredicate> ∈ {…}` fragments —
// the **wire** namespace (per umbrella §R4's two-surface split). The
// chip top-line shows the friendly token; this caption shows the wire
// predicate the BFF actually receives.

export function TranslatedCaption({ chips }) {
  const predicateChips = (chips || []).filter((c) => c.kind === 'predicate');
  if (predicateChips.length === 0) return null;

  const fragments = predicateChips.map((c) => {
    const wire = c.wirePredicate;
    const values = (c.values || []).join(', ');
    // Range predicates render as comparisons rather than set membership.
    if (wire === 'committedAt>=') return `committedAt ≥ ${values}`;
    if (wire === 'committedAt<') return `committedAt < ${values}`;
    return `${wire} ∈ {${values}}`;
  });

  return (
    <div className="library-translated-caption" aria-label="Translated to query_entities">
      <span className="library-translated-caption-label">Translated to query_entities</span>
      <span className="library-translated-caption-body">
        {fragments.join(' · ')}
      </span>
    </div>
  );
}
